import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../_common/application/ts/Glob';
import GlobalState from '../../../_common/platform/ts/globalStates/GlobalState';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import { ICreateLinkOptions } from '../ts/stores/WorkspaceStore';
import { IScopeOptions } from '../../../_common/platform/tsx/filtering/Interfaces';

interface IWorkspaceLinkParametersValue {
    includeFilters: boolean;
    excludePeriodFilter: boolean;
    distractFree: boolean;
    anonymousLogin: boolean;
    saveActiveTabs: boolean;
    saveDrillDownState: boolean;
    useGuidsAsWSID: boolean;
}

function WorkspaceLinkParameters(props: {
    setConfirmValueGetter(getConfirmValue);
    unsetConfirmValueGetter?();

    options: ICreateLinkOptions;
    glob: IGlob;
}) {
    const [includeFilters, setIncludeFilters] = React.useState(false);
    const [excludePeriodFilter, setExcludePeriodFilter] = React.useState(false);
    const [distractFree, setDistractFree] = React.useState(false);
    const [anonymousLogin, setAnonymousLogin] = React.useState(false);
    const [useGuidsAsWSID, setUseGuidsAsWSID] = React.useState(false);
    const [saveActiveTabs, setSaveActiveTabs] = React.useState(true);
    const [saveDrillDownState, setSaveDrillDownState] = React.useState(true);

    React.useEffect(() => {
        const getConfirmValue: () => IWorkspaceLinkParametersValue = () => {
            const result: IWorkspaceLinkParametersValue = {
                includeFilters: includeFilters,
                excludePeriodFilter: excludePeriodFilter,
                distractFree: distractFree,
                anonymousLogin: anonymousLogin,
                useGuidsAsWSID: useGuidsAsWSID,
                saveActiveTabs: saveActiveTabs,
                saveDrillDownState: saveDrillDownState
            };

            return result;
        };

        props.setConfirmValueGetter(getConfirmValue);

        return () => {
            if (typeof props.unsetConfirmValueGetter === 'function') {
                props.unsetConfirmValueGetter();
            }
        };
    });

    const drillDownState = props.options.drillDownState;

    let includeFiltersElement: React.JSX.Element;
    let excludePeriodFilterElement: React.JSX.Element;

    if (drillDownState == null || _.isEmpty(drillDownState)) {
        includeFiltersElement = (
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={includeFilters}
                    allowNull={false}
                    title={'Include Filters'}
                    onChange={(value) => {
                        setIncludeFilters(value);
                    }}
                />
            </div>
        );

        excludePeriodFilterElement = (
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={excludePeriodFilter}
                    allowNull={false}
                    title={'Exclude Period Filter'}
                    onChange={(value) => {
                        setExcludePeriodFilter(value);
                    }}
                />
            </div>
        );
    }

    let saveDrillDownStateElement: React.JSX.Element;

    if (drillDownState != null && !_.isEmpty(drillDownState)) {
        saveDrillDownStateElement = (
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={saveDrillDownState}
                    allowNull={false}
                    title={'Preserve Drilldown State'}
                    onChange={(value) => {
                        setSaveDrillDownState(value);
                    }}
                />
            </div>
        );
    }

    return (
        <div>
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={distractFree}
                    allowNull={false}
                    title={'Hide Top Menu Bar'}
                    onChange={(value) => {
                        setDistractFree(value);
                    }}
                />
            </div>

            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={anonymousLogin}
                    allowNull={false}
                    title={'Use Anonymous Login'}
                    onChange={(value) => {
                        setAnonymousLogin(value);
                    }}
                />
            </div>

            {includeFiltersElement}
            {excludePeriodFilterElement}

            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={useGuidsAsWSID}
                    allowNull={false}
                    title={'Use GUID as Workspace Identifier'}
                    onChange={(value) => {
                        setUseGuidsAsWSID(value);
                    }}
                />
            </div>

            <div className="col-sm mb-2">
                <BooleanField
                    value={saveActiveTabs}
                    allowNull={false}
                    title={'Preserve Active Tabs for Tabbed Widget Container'}
                    onChange={(value) => {
                        setSaveActiveTabs(value);
                    }}
                />
            </div>

            {saveDrillDownStateElement}
        </div>
    );
}

export function openCreateWorkspaceLinkDialog(
    workspaceID: number,
    tabID: number,
    tabDisplay: number,
    name: string,
    scopeOptions: IScopeOptions,
    glob: IGlob
) {
    const drillDownState = glob.WorkspaceStore.getInstanceState(workspaceID).drillDownState;

    glob.DialogActions.createDialogCustom(
        'Create Workspace Link',
        (value: IWorkspaceLinkParametersValue) => {
            let paramString: string;

            if (value.includeFilters || (value.saveDrillDownState && !_.isEmpty(drillDownState))) {
                const globalState = GlobalState.getGlobalState(glob, tabID);

                paramString = globalState.getFilterAsURLParameters(scopeOptions, {
                    excludePeriodFilter: value.excludePeriodFilter
                });
            }

            const options: ICreateLinkOptions = { ...value };

            if (value.saveActiveTabs) {
                const activeWidgets = glob.WorkspaceStore.getInstanceState(workspaceID).activeWidgets;

                if (!_.isEmpty(activeWidgets)) {
                    options.activeWidgets = activeWidgets;
                }
            }

            if (value.saveDrillDownState && !_.isEmpty(drillDownState)) {
                options.drillDownState = drillDownState;
            }

            glob.AppActions.workspaceCreateLink(workspaceID, tabDisplay, name, paramString, options);
        },
        () => {},
        () => {},
        {
            deny: false,
            confirmTitle: 'OK',
            resizable: false,

            Component: WorkspaceLinkParameters,
            componentOptions: {
                glob: glob,
                drillDownState
            }
        }
    );
}
